import { getParentPath } from "./getParentPath";

export function getAllParentPaths(path: string): string[] {
  let parentPath = getParentPath(path);
  const parentPaths = [];
  while (parentPath !== "/") {
    parentPaths.unshift(parentPath);
    parentPath = getParentPath(parentPath);
  }
  return parentPaths;
}
